import { Link } from "react-router-dom";
import { MarketingPage } from "@/components/marketing/MarketingPage";
import { Button } from "@/components/ui/button";
import { PAGE_BANNERS } from "@/lib/assets";
import { Users, Compass, LineChart, Building2, ArrowRight } from "lucide-react";

const AUD = [
  { icon: Users, t: "Students", color: "#78be21",
    points: ["See your own TSB, domain & skill breakdown", "Run what-if degree changes and re-rank careers", "Ask the AI Skills Coach why you fit — and what to strengthen"] },
  { icon: Compass, t: "Advisors & Faculty", color: "#005291",
    points: ["View assigned student profiles", "Spot the weakest skill per student", "Plan targeted, timely interventions"] },
  { icon: LineChart, t: "Administrators", color: "#10b981",
    points: ["Cohort TSB distributions & program comparisons", "Equity-gap views (first-gen, Pell)", "Auditable trail of every score change"] },
  { icon: Building2, t: "Employers", color: "#003057",
    points: ["Browse opt-in student summaries only", "Submit structured 360 reviews", "Feed a verified, reversible skill signal"] },
];

export default function Audiences() {
  return (
    <MarketingPage
      eyebrow="For You"
      banner={PAGE_BANNERS.foryou}
      title="One benchmark, four scoped experiences"
      lead="Role-based access keeps the right data with the right people. Students see only themselves; employers see only opt-in summaries; advisors see their caseload; admins see the institution."
    >
      <div className="grid grid-cols-1 gap-6 md:grid-cols-2">
        {AUD.map((a) => (
          <div key={a.t} className="rounded-2xl border border-slate-200 bg-white p-6 card-elevate">
            <div className="flex h-12 w-12 items-center justify-center rounded-xl" style={{ backgroundColor: `${a.color}18` }}>
              <a.icon className="h-6 w-6" style={{ color: a.color }} />
            </div>
            <h3 className="mt-4 font-heading text-xl font-bold text-[#003057]">{a.t}</h3>
            <ul className="mt-3 space-y-2">
              {a.points.map((p) => (
                <li key={p} className="flex gap-2 text-sm text-slate-600">
                  <span className="mt-1.5 h-1.5 w-1.5 flex-shrink-0 rounded-full" style={{ backgroundColor: a.color }} />
                  {p}
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>
      <div className="mt-12 flex justify-center">
        <Link to="/login">
          <Button size="lg" className="rounded-full bg-[#003057] px-8 text-base font-bold text-white hover:bg-[#004275]">
            Sign in to the demo <ArrowRight className="ml-2 h-5 w-5" />
          </Button>
        </Link>
      </div>
    </MarketingPage>
  );
}
